// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { processLock } from '@supabase/auth-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // Use an in-tab lock instead of the cross-tab Web Locks API.
    // A frozen/duplicated tab can hold the navigator lock forever, which
    // deadlocks every Supabase request in the other tabs (blank app / no data).
    lock: processLock,
  }
});